import axios from 'axios';
import { Log } from '../types/Log';
import { formatToLocale, stringToUTC } from '../utils/dateUtils';
import { KAPTAIN_URL } from './config';

export const getLogList = async (): Promise<Log[]> => {
  const response = await axios.get<Log[]>(`${KAPTAIN_URL}/api/log/list`);
  const raw = response.data;
  return raw.map((item) => {
    return {
      ...item,
      lastRunAt: formatToLocale(stringToUTC(item.lastRunAt), 'yyyy-MM-dd hh:mm:ss'),
      lastFinishedAt: formatToLocale(stringToUTC(item.lastFinishedAt), 'yyyy-MM-dd hh:mm:ss'),
      timeConsuming: stringToUTC(item.lastFinishedAt) - stringToUTC(item.lastRunAt)
    };
  });
};